import { render, staticRenderFns } from "./numbersList.vue?vue&type=template&id=34122f5b"
import script from "./numbersList.vue?vue&type=script&lang=js"
export * from "./numbersList.vue?vue&type=script&lang=js"
import style0 from "./numbersList.vue?vue&type=style&index=0&id=34122f5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports